export default {"src":"/_next/static/media/vai-logo.261031e7.svg","height":90,"width":56};